import Vue from 'vue'

// v-dialogDrag: 弹窗拖拽
Vue.directive('dialogDrag', {
  bind(el, binding, vNode) {
    // 弹框可拉伸最小宽高
    let minWidth = 480
    let minHeight = 720

    // 弹框可拉伸最大宽高
    let maxWidth = 1700
    let maxHeight = 765

    const dialogHeaderEl = el.querySelector('.el-dialog__header')
    const dragDom = el.querySelector('.el-dialog')
    dialogHeaderEl.style.cssText += ';cursor: move;'

    // 获取原有属性ie dom元素.currentStyle 火狐谷歌window.getComputedStyle（dom元素，null）
    const getStyle = (function () {
      if (window.document.currentStyle) {
        return (dom, attr) => dom.currentStyle[attr]
      } else {
        return (dom, attr) => getComputedStyle(dom, false)[attr]
      }
    })()

    dialogHeaderEl.onmousedown = e => {
      dragDom.style.userSelect = 'none'
      const disX = e.clientX - dialogHeaderEl.offsetLeft
      const disY = e.clientY - dialogHeaderEl.offsetTop

      const dragDomWidth = dragDom.offsetWidth
      const dragDomHeight = dragDom.offsetHeight

      const screenWidth = document.body.clientWidth
      const screenHeight = document.body.clientHeight

      const minDragDomLeft = dragDom.offsetLeft
      const maxDragDomLeft = screenWidth - minDragDomLeft - dragDomWidth

      const minDragDomTop = dragDom.offsetTop
      // const maxDragDomTop = screenHeight - minDragDomTop - dragDomHeight
      
      let maxDragDomTop = ''
      if (screenHeight - minDragDomTop - dragDomHeight < 0) {
        maxDragDomTop = 0
      } else {
        maxDragDomTop = screenHeight - minDragDomTop - dragDomHeight
      }

      let styL = getStyle(dragDom, 'left')
      let styT = getStyle(dragDom, 'top')

      if (styL.includes('%')) {
        styL = +document.body.clientWidth * (+styL.replace(/%/g, '') / 100)
        styT = +document.body.clientHeight * (+styT.replace(/%/g, '') / 100)
      } else {
        styL = +styL.replace(/\px/g, '')
        styT = +styT.replace(/\px/g, '')
      }

      document.onmousemove = function (e) {
        let left = e.clientX - disX
        let top = e.clientY - disY

        if (-left > minDragDomLeft) {
          left = -minDragDomLeft
        } else if (left > maxDragDomLeft) {
          left = maxDragDomLeft
        }

        if (-top > minDragDomTop) {
          top = -minDragDomTop
        } else if (top > maxDragDomTop) {
          top = maxDragDomTop
        }

        dragDom.style.cssText += `;left: ${left + styL}px; top: ${top + styT}px;right:auto;bottom:auto`

        vNode.child.$emit('dragDialog')
      }

      document.onmouseup = function () {
        document.onmousemove = null
        document.onmouseup = null
        dragDom.style.userSelect = 'text'
      }
    }

    dragDom.onmousemove = function (e) {
      if (e.clientX > dragDom.offsetLeft + dragDom.clientWidth - 10 || dragDom.offsetLeft + 10 > e.clientX) {
        dragDom.style.cursor = 'w-resize'
        dragDom.style.userSelect = 'none'
      } else if (el.scrollTop + e.clientY > dragDom.offsetTop + dragDom.clientHeight - 10) {
        dragDom.style.cursor = 's-resize'
        dragDom.style.userSelect = 'none'
      } else {
        dragDom.style.cursor = 'default'
        dragDom.style.userSelect = 'text'
        dragDom.onmousedown = null
      }

      dragDom.onmousedown = (e) => {
        const clientX = e.clientX
        const clientY = e.clientY
        let elW = dragDom.clientWidth
        let elH = dragDom.clientHeight

        let elOffsetLeft = dragDom.offsetLeft
        let elOffsetTop = dragDom.offsetTop
        let ELscrollTop = el.scrollTop

        // 判断点击的位置是不是为头部
        if (clientX > elOffsetLeft && clientX < elOffsetLeft + elW && clientY > elOffsetTop && clientY < elOffsetTop + 100) {
          // 如果是头部在此就不做任何动作，以上有绑定dialogHeaderEl.onmousedown = moveDown;
        } else {
          document.onmousemove = function (e) {
            // 左侧鼠标拖拽位置
            if (clientX > elOffsetLeft && clientX < elOffsetLeft + 10) {
              // 往左拖拽
              if (clientX > e.clientX) {
                dragDom.style.width = elW + (clientX - e.clientX) * 2 + 'px'
              }

              // 往右拖拽
              if (clientX < e.clientX) {
                if (dragDom.clientWidth < minWidth) {
                } else {
                  dragDom.style.width = elW - (e.clientX - clientX) * 2 + 'px'
                }
              } else {
                if (dragDom.clientWidth > maxWidth) {
                  elW = '1700px'
                } else {

                }
              }
            }

            // 右侧鼠标拖拽位置
            if (clientX > elOffsetLeft + elW - 10 && clientX < elOffsetLeft + elW) {
              // 往左拖拽
              if (clientX > e.clientX) {
                if (dragDom.clientWidth < minWidth) {
                } else {
                  // 移动时禁用默认事件
                  e.preventDefault()
                  dragDom.style.width = elW - (clientX - e.clientX) * 2 + 'px'
                }
              } else {
                if (dragDom.clientWidth > maxWidth) {
                  elW = '1700px'
                } else {

                }
              }

              // 往右拖拽
              if (clientX < e.clientX) {
                // 移动时禁用默认事件
                e.preventDefault()
                dragDom.style.width = elW + (e.clientX - clientX) * 2 + 'px'
              }
            }

            // 底部鼠标拖拽位置
            if (ELscrollTop + clientY > elOffsetTop + elH - 20 && ELscrollTop + clientY < elOffsetTop + elH) {
              // 往上拖拽
              if (clientY > e.clientY) {
                if (dragDom.clientHeight < minHeight) {
                } else {
                  // 移动时禁用默认事件
                  e.preventDefault()
                  dragDom.style.height = elH - (clientY - e.clientY) * 2 + 'px'
                }
              } else if (dragDom.clientHeight > maxHeight) {
                elH = '765px'
              }

              // 往下拖拽
              if (clientY < e.clientY) {
                // 移动时禁用默认事件
                e.preventDefault()
                dragDom.style.height = elH + (e.clientY - clientY) * 2 + 'px'
              }
            }
          }

          // 拉伸结束
          document.onmouseup = function (e) {
            dragDom.style.userSelect = 'text'
            document.onmousemove = null
            document.onmouseup = null
          }
        }
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/directive/dialogdrag.js